<script setup lang="ts">
import { CupraButton } from '@/components/cupra/button'
import { CupraInput } from '@/components/cupra/input'
import { ref } from 'vue'

const props = defineProps<{
    postalCode?: string
}>()

const emit = defineEmits(['submit'])

const postalCode = ref<string>(props.postalCode || '')
const postalCodeError = ref<string>()

const submitIfPossible = () => {
    if (!postalCode.value) {
        postalCodeError.value = 'Vul je postcode in'
        return
    } else if (!postalCode.value.match(/\d{4}[A-Za-z]{2}/)) {
        postalCodeError.value = 'Vul een geldige postcode in (1111AA)'
    } else {
        postalCodeError.value = undefined
    }

    emit('submit', postalCode.value)
}
</script>

<template>
    <div class="mt-1.5 mb-3">
        <slot />
    </div>
    <form
        class="mt-6 flex flex-col gap-3 sm:flex-row"
        @submit.prevent="submitIfPossible()"
    >
        <CupraInput
            type="text"
            placeholder="Postcode (1111AA)"
            v-model="postalCode"
            maxlength="6"
            :error="postalCodeError"
        />
        <CupraButton type="submit">Vind locaties</CupraButton>
    </form>
</template>
